import { arrayOf, func, number, string } from 'prop-types';
import React from 'react';

import Association from '../../../associations/Association';
import SingleSelect from '../../../generic/SingleSelect';
import {
  invoiceBillingTypes,
  invoiceTypeOptions,
  salesChannels,
} from '../../../opportunities/constants';

function FilterInvoices({
  billingType,
  type,
  ownerId,
  onChange,
  salesChannel,
  merchantIds,
}) {
  return (
    <>
      <Association
        id="inv-ownerId"
        name="ownerId"
        value={ownerId}
        type="user"
        disableInactiveView
        className="filter-item"
        placeholder="Owner"
        onChange={onChange}
      />
      <SingleSelect
        options={[{ label: '-- Type --', value: '' }, ...invoiceTypeOptions]}
        id="inv-type"
        name="type"
        value={type}
        className="filter-item"
        onChange={onChange}
        placeholder="Type"
      />
      <SingleSelect
        options={[
          { label: '-- Billing Type --', value: '' },
          ...invoiceBillingTypes,
        ]}
        id="inv-billingType"
        name="billingType"
        value={billingType}
        className="filter-item"
        onChange={onChange}
        placeholder="Billing Type"
      />
      <SingleSelect
        options={[
          { label: '-- Sales Channel --', value: '' },
          ...salesChannels,
        ]}
        id="inv-salesChannel"
        name="salesChannel"
        value={salesChannel}
        className="filter-item"
        onChange={onChange}
        placeholder="Sales Channel"
      />
      <Association
        id="inv-merchants"
        name="merchants"
        value={merchantIds}
        type="merchant"
        disableInactiveView
        hideAddButton
        className="filter-item"
        placeholder="Merchant"
        onChange={onChange}
      />
    </>
  );
}

FilterInvoices.propTypes = {
  onChange: func.isRequired,
  billingType: string,
  type: string,
  ownerId: number,
  salesChannel: string,
  merchantIds: arrayOf(number),
};

FilterInvoices.defaultProps = {
  billingType: '',
  type: '',
  ownerId: null,
  salesChannel: '',
  merchantIds: null,
};

export default FilterInvoices;
